export default __webpack_public_path__ + "static/media/testimonials-bg.0e8faca3.png";